export default __webpack_public_path__ + "static/media/77_desktop.54479b80.jpg";